import { ISearchWidget } from 'features/search-widget';

const stayzSearchWidgetConfig: Record<string, ISearchWidget> = {
  'au-stayz': {
    branding: {
      logo: {
        url: 'https://www.stayz.com.au/_dms/header/logo.svg?siteid=9005044&locale=en_AU&3ec60977',
        description: 'Stayz.com.au',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.stayz.com.au',
      searchParams: {
        siteid: '9005044',
        langid: '3081',
      },
      stays: {
        pathname: '/search',
      },
    },
  },
};

export { stayzSearchWidgetConfig };
